import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48c05bca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fenye" }

import MainCard from "../components/MainCard.vue";
import { GetAllBook } from "../http/index";
import { ref, watch } from "vue";
import { Calendar, Search } from "@element-plus/icons-vue";
import "animate.css";
import { id, tr } from "element-plus/es/locale";
import { ElMessage } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'Main',
  setup(__props) {

const totalCount = ref(1000);
const query = ref();
query.value = {
  PageSize: 12,
  PageIndex: 1,
  Search: "",
};
const Book = ref();
const GetBook = async () => {
  try {
    const res=(await GetAllBook(query.value)).data.response;
    Book.value = res.data;
    totalCount.value = res.dataCount;
  } catch (error) {
    ElMessage.error(`error:${error.message}`);
  }
};
const handlePageSizeChange = (pageSize: any) => {
  query.value.pageSize = pageSize;
  GetBook();
};
const handleCurrentPageChange = (PageIndex: any) => {
  query.value.PageIndex = PageIndex;
  GetBook();
};
watch(
  () => query.value.Search,
  (newvalue, oldvalue) => {
    if (newvalue != oldvalue) {
      query.value.Search = newvalue;
      GetBook();
    }
  }
);

GetBook();

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 3 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: query.value.Search,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query.value.Search) = $event)),
              class: "w-50 m-2",
              placeholder: "书签名"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "el-input__icon" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Search))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 12 }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Book.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            span: 6,
            style: {"margin-top":"10px"},
            key: "index",
            class: "animate__animated h"
          }, {
            default: _withCtx(() => [
              _createVNode(MainCard, { Book: item }, null, 8, ["Book"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handlePageSizeChange,
        onCurrentChange: handleCurrentPageChange,
        "current-page": query.value.PageIndex,
        "page-size": query.value.PageSize,
        background: "",
        layout: "prev, pager, next, jumper",
        total: totalCount.value
      }, null, 8, ["current-page", "page-size", "total"])
    ])
  ], 64))
}
}

})